import { TalentPickServiceData } from "@tvg/ts-types/TalentPicks";
import { TalentPickGraphData } from "@tvg/ts-types/Race";

const transformTalentPickToGraph = (data: TalentPickServiceData) =>
  ({
    id: data.id,
    amount: data.amount,
    price: data.price,
    selections: data.selections ?? [],
    favorites: data.favorites ?? [],
    talent: {
      talentId: data.talent.talentId,
      name: data.talent.name,
      pictureUrl: data.talent.pictureUrl,
      phrases: data.talent.phrases,
      tvgAccountId: data.talent.tvgAccountId
    },
    race: {
      id: `${data.track}-${data.race}`,
      number: `${data.race}`,
      track: {
        id: data.track,
        code: data.track,
        name: data.trackName
      },
      mtp: data.mtp,
      postTime: data.racePostTime,
      status: {
        code: data.raceStatus
      },
      type: {
        code: data.raceType
      }
    },
    wagerType: {
      type: {
        code: data.wagerType.abbreviation
      },
      legCount: data.wagerType.legCount,
      isBox: data.wagerType.isBox,
      isKey: data.wagerType.isKey,
      isWheel: data.wagerType.isWheel
    },
    published: data.published
  }) as unknown as TalentPickGraphData;

export default transformTalentPickToGraph;
